import { useEffect } from "react";
import { useRouter } from "next/router";

import GeneralYogaPage from "./GeneralYogaPage";
import GeneralNutritionPage from "./GeneralNutritionPage";
import IndiansLivingAbroadPage from "./IndiansLivingAbroadPage";
import NutritionDietPlanPage from "./NutritionDietPlanPage";
import NutritionForHealthConditionPage from "./NutritionForHealthConditionPage";
import NutritionBootcampPage from "./NutritionBootcampPage";
import YogaNutritionBootcampPage from "./YogaNutritionBootcampPage";
import YogaForHealthConditionPage from "./YogaForHealthConditionPage";
import YogaBootcampPage from "./YogaBootcampPage";
import OneOnOneYogaPage from "./OneOnOneYogaPage";

import { timezone } from "@/utils";

import { useAppDispatch, useAppSelector } from "@/hooks";
import * as actions from "@/redux/BootCampReducer";
import { appendFreshChatScript } from "../../../utils/Scripts/index"

interface BootCampLandingPageProps {}

const BootCampLandingPage: React.FC<BootCampLandingPageProps> = () => {
  const router = useRouter();
  const dispatch = useAppDispatch();

  const { data } = useAppSelector((state) => state.bootCamp);

  const { query } = router;

  let bootcampType =
    typeof query?.bootcampType === "string"
      ? query?.bootcampType
      : query?.bootcampType?.[0] || "";

  let pageSlug =
    typeof query?.slug === "string" ? query?.slug : query?.slug?.[0] || "";

  const pageType = data?.pageType || "";

  useEffect(() => {
      appendFreshChatScript()
  },[])

  useEffect(() => {
    handleRouteChange()
    router.events.on('routeChangeComplete', handleRouteChange);

    return () => {
      router.events.off('routeChangeComplete', handleRouteChange);
    };
  }, [router.events,dispatch, bootcampType, pageSlug]);
  
  const handleRouteChange = () => {
    let data = {
      bootcampType,
      pageSlug,
      timezone,
    };

    if (!pageSlug) {
      data = {
        bootcampType: "general",
        pageSlug: bootcampType,
        timezone,
      };
    }
    dispatch(actions.getBootCampPageData(data));
  };


  switch (pageType) {
    case "GENERAL_YOGA":
      return <GeneralYogaPage />;
    case "GENERAL_NUTRITION":
      return <GeneralNutritionPage />;
    case "INDIANS_LIVING_ABROAD":
      return <IndiansLivingAbroadPage />;
    case "NUTRITION_DIET_PLAN":
      return <NutritionDietPlanPage />;
    case "NUTRITION_FOR_HEALTH_CONDITION":
      return <NutritionForHealthConditionPage />;
    case "NUTRITION_BOOTCAMP":
      return <NutritionBootcampPage />;
    case "YOGA_NUTRITION_BOOTCAMP":
      return <YogaNutritionBootcampPage />;
    case "YOGA_FOR_HEALTH_CONDITION":
      return <YogaForHealthConditionPage />;
    case "YOGA_BOOTCAMP":
      return <YogaBootcampPage />;
    case "ONE_ON_ONE_YOGA":
      return <OneOnOneYogaPage />;
    default:
      return null;
  }
};

export default BootCampLandingPage;
